export default function BrawlArenaIcon() {
  return (
    <svg viewBox="0 0 64 64" aria-hidden="true">
      <path d="M8 44 H56 L50 54 L36 60 L18 56 Z" fill="#5B4636" />
      <rect x="6" y="40" width="52" height="7" rx="3" fill="#4CC36A" />
      <rect x="22" y="22" width="20" height="4" rx="2" fill="#C98A4B" />
      <rect x="10" y="20" width="14" height="20" rx="7" fill="#2F8BFF" />
      <rect x="10" y="24" width="14" height="3" fill="#8CC6FF" />
      <circle cx="19" cy="30" r="2" fill="#FFFFFF" />
      <g transform="rotate(-25 46 18)">
        <rect x="39" y="8" width="14" height="20" rx="7" fill="#FF8A1F" />
        <rect x="39" y="12" width="14" height="3" fill="#FFC285" />
      </g>
      <path d="M27 26 l6 -6 M29 30 l8 -4 M28 22 l3 -8" stroke="#FFE36B" strokeWidth="3" strokeLinecap="round" />
      <text x="50" y="38" fontSize="9" fontWeight="bold" fill="#FFFFFF" fontFamily="sans-serif">%</text>
    </svg>
  );
}
